import { useLocation } from "@reach/router";
import { navigate } from "gatsby";
import { useEffect, useState } from "react";
import { PARAMS_TO_PRESERVE } from "./constants";

const useQueryPreservingNavigate = () => {
  const location = useLocation();
  const [queryParams, setQueryParams] = useState("");

  useEffect(() => {
    setQueryParams(location.search);
  }, [location]);

  const constructUrl = (to) => {
    const existingParams = new URLSearchParams(queryParams);

    existingParams.forEach((_value, key) => {
      if (!PARAMS_TO_PRESERVE.includes(key)) existingParams.delete(key);
    });

    // If URL already has params, merge them
    if (to.includes("?")) {
      const [path, newParams] = to.split("?");

      const newParamsObj = new URLSearchParams(newParams);

      // Merge params, with new ones taking precedence
      newParamsObj.forEach((value, key) => {
        existingParams.set(key, value);
      });

      return `${path}?${existingParams.toString()}`;
    }

    // If no params in target URL, just append existing ones
    return `${to}${to.endsWith("/") ? "" : "/"}?${existingParams.toString()}`;
  };

  const navigateWithParams = (to, options) => {
    return navigate(constructUrl(to), options);
  };

  return navigateWithParams;
};

export default useQueryPreservingNavigate;
